import { NonNilProperty } from "../types";
import { isDefined } from "./is-defined";

export function isPropertyDefined<T, K extends keyof T>(
    value: T | null | undefined,
    field: K,
): value is NonNilProperty<T, K> {
    return isDefined(value?.[field]);
}
